import { RegistrableOrganisation } from "../../../types/registration";

export function isAlreadyRegistered(org: RegistrableOrganisation): boolean {
  return org.registrationStatus === "ALREADY_REGISTRED";
}
